import React from 'react';
import LocalizedStrings from 'localized-strings';
import { Root, Header } from './styles';
import stringsToLocalize from '../../../localisation';

const strings = new LocalizedStrings(stringsToLocalize);
const Other = (props) => {
  let lang = 'En';
  if (props.Language) {
    lang = props.Language;
    strings.setLanguage(lang);
  }
  return (
    <Root>
      <Header>
        <p dir={strings.dir}>{strings.notSupported}</p>
      </Header>
    </Root>
  );
};

export default Other;
